import { useState } from "react";
import { useMusicPlayer } from "@/providers/music-provider/music-provider";

export default function useModal() {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const { closePlayer } = useMusicPlayer();

  const [isClosing, setIsClosing] = useState(false);
  const closeModal = () => {
    closePlayer();
    setIsClosing(true);
    setTimeout(() => {
      setIsOpen(false);
      setIsClosing(false);
    }, 150);
  };

  return {
    isOpen,
    isClosing,
    openModal,
    closeModal,
  };
}
